import gql from 'graphql-tag'
import { ApolloClient } from '@apollo/client'

const MUTATION = gql`
  mutation {
    issueTestRegistrationKey {
      keyId
      privateKeyData
    }
  }
`

interface IssueTestRegistrationKeyResult {
  keyId: string
  privateKeyData: string
  publicKeyData: string
}

export async function issueTestRegistrationKey(
  client: ApolloClient<unknown>,
): Promise<IssueTestRegistrationKeyResult | undefined> {
  const result = await client.mutate<{
    issueTestRegistrationKey: IssueTestRegistrationKeyResult
  }>({
    mutation: MUTATION,
  })

  return result.data?.issueTestRegistrationKey
}
